const e=async(e,t,n)=>{let{data:r}=await e.get(`/orgs/${t}/apps/${n}`);return r};export{e as getOrgAppAssignment};
//# sourceMappingURL=get-org-app-assignment.mjs.map